import React from 'react'
import { LuRefreshCcw } from "react-icons/lu";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { Button } from 'react-bootstrap';
const RefreshButton = ({ refreshCallback, title = "Refresh List" }) => {
  return (
   <>
    <OverlayTrigger overlay={<Tooltip>{title}</Tooltip>}>
      <Button
         variant="primary"
        className="btn btn-outline-secondary mx-2"
        onClick={refreshCallback}
        style={{ padding: "8px 11px" }}
      >
       <LuRefreshCcw />
      </Button>
    </OverlayTrigger>
   </>
  )
}

export default RefreshButton